import { ACTION_TYPES } from '../Constants';
import { fetchAboutMunicipality } from '../Utils/fetcherUtil';

const fetchAboutMunicipalityStarted = () => (
  { type: ACTION_TYPES.FETCH_ABOUT_MUNICIPALITY_STARTED }
);

const fetchAboutMunicipalitySucceeded = data => (
  { type: ACTION_TYPES.FETCH_ABOUT_MUNICIPALITY_SUCCEEDED, data }
);

const fetchAboutMunicipalityFailed = error => (
  { type: ACTION_TYPES.FETCH_ABOUT_MUNICIPALITY_FAILED, error }
);

export const fetchAboutMunicipalityData = municipalityName => (dispatch) => {
  dispatch(fetchAboutMunicipalityStarted());
  fetchAboutMunicipality(municipalityName).then((response) => {
    if (response.status === 200) {
      dispatch(fetchAboutMunicipalitySucceeded(response.data));
    }
  }).catch((error) => {
    dispatch(fetchAboutMunicipalityFailed(error));
    console.log('error', error);
  });
};



// WEBPACK FOOTER //
// ./src/Actions/AboutMunicipalityActions.js